module.exports = "<scxml\n  xmlns=\"http://www.w3.org/2005/07/scxml\"\n  version=\"1.0\"\n  name=\"twoButtonLamp\">\n  <state id=\"off\">\n    <transition event=\"switch-on\" target=\"on\"/>\n  </state>\n  <state id=\"on\">\n    <transition event=\"switch-off\" target=\"off\"/>\n  </state>\n</scxml>\n"


//////////////////
// WEBPACK FOOTER
// ./src/examples/two-button-lamp/two-button-lamp.scxml
// module id = 899
// module chunks = 199390669437303